/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ChargeableTripsList,
    ChargeableTripsListFromJSON,
    ChargeableTripsListToJSON,
} from '../models';

export interface SelectChargeableTripsRequest {
    officeIds: Array<number>;
    officeId?: number;
    driverId?: number;
    startDate?: number;
    endDate?: number;
}

/**
 * 
 */
export class UsageTripApi extends runtime.BaseAPI {

    /**
     * 1Tripごとの利用実績
     */
    async selectChargeableTripsRaw(requestParameters: SelectChargeableTripsRequest): Promise<runtime.ApiResponse<ChargeableTripsList>> {
        if (requestParameters.officeIds === null || requestParameters.officeIds === undefined) {
            throw new runtime.RequiredError('officeIds','Required parameter requestParameters.officeIds was null or undefined when calling selectChargeableTrips.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.officeIds) {
            queryParameters['office_ids'] = requestParameters.officeIds.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters.officeId !== undefined) {
            queryParameters['office_id'] = requestParameters.officeId;
        }

        if (requestParameters.driverId !== undefined) {
            queryParameters['driver_id'] = requestParameters.driverId;
        }

        if (requestParameters.startDate !== undefined) {
            queryParameters['start_date'] = requestParameters.startDate;
        }

        if (requestParameters.endDate !== undefined) {
            queryParameters['end_date'] = requestParameters.endDate;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/chargeable_trips`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ChargeableTripsListFromJSON(jsonValue));
    }

    /**
     * 1Tripごとの利用実績
     */
    async selectChargeableTrips(requestParameters: SelectChargeableTripsRequest): Promise<ChargeableTripsList> {
        const response = await this.selectChargeableTripsRaw(requestParameters);
        return await response.value();
    }

}
